import { IConfig } from '@cian/config/shared';

interface IParams {
  config: IConfig;
  search: string;
  isNewPublishTermsEnabled: boolean;
}

export const getIsNewPublishTermsEnabled = (params: IParams): boolean => {
  const { config, search, isNewPublishTermsEnabled } = params;

  // Принудительная активация Новой ФВУ
  const isForceNewPublishTerms = !!config.get<boolean>('isForceNewPublishTerms');
  // Параметр в урле
  const isQASearchParamExist = search.includes('qaNewPublishTerms');

  return isForceNewPublishTerms || isQASearchParamExist || isNewPublishTermsEnabled;
};
